import React from 'react'
import classNames from 'classnames'
import { InternalLink } from '@/atoms/InternalLink'
import { ParagraphSM } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { projectTypes } from '@/constants/projectTypes'
import { useProjectMeta } from '@/contexts/ProjectMetaContext'
import { useTranslate } from '@/utils/translate/translate-client'

interface CheckoutLegalTermsProps {
  className?: string
}
export const CheckoutLegalTerms: React.FC<CheckoutLegalTermsProps> = ({ className }) => {
  const { t } = useTranslate('pif')
  const { name, projectType } = useProjectMeta()
  return (
    <ParagraphSM
      className={classNames('pt-6 mb-4 px-2 leading-[16px] uppercase text-[0.625rem] opacity-50', className)}
    >
      {t(
        'expressCheckoutLegalTermsV7',
        'Upon submitting my Pay it Forward payment, I acknowledge and agree that Angel Studios becomes the owner of all funds upon receipt. Your Pay it Forward purchase, like other entertainment purchases, is meant to increase the audience and reach of the {{projectType}} {{projectName}}; it is not a donation.',
        { projectType: projectType === projectTypes.movie ? t('film', 'film') : t('show', 'show'), projectName: name },
      )}

      <InternalLink className="ml-1 uppercase underline" href={`${paths.legal.termsOfUse}#pay-it-forward`}>
        {t('termAndConditions', 'Terms and Conditions')}
      </InternalLink>
    </ParagraphSM>
  )
}
